import { AccountType, AccountTypeTranslator } from "../types/Accounts.types";

import { FiltersProps } from "@/core/libs/list-data/lib/filters/interfaces";
import { ListDataFiltersTypeEnum } from "@/core/libs/list-data/lib/interfaces/enums";
import { cpfCnpjFormatter } from "@/utils/FormatCPForCNPJ";

const removeMask = (value: string) => {
  return value?.replace(/\D/g, "");
};

export const accountFilters: FiltersProps[] = [
  {
    label: "Nome",
    placeholder: "Nome",
    filterQuery: "fullName",
    type: ListDataFiltersTypeEnum.TEXT,
    maxWidth: "200px"
  },
  {
    label: "Tipo",
    placeholder: "Tipo",
    type: ListDataFiltersTypeEnum.SELECT,
    filterQuery: "accountType",
    options: [
      { key: AccountType.LEGAL, text: AccountTypeTranslator.LEGAL },
      { key: AccountType.PHYSICAL, text: AccountTypeTranslator.PHYSICAL }
    ],
    minWidth: "150px",
    maxWidth: "150px"
  },
  {
    label: "CPF/CNPJ",
    placeholder: "CPF/CNPJ",
    filterQuery: "documentNumber",
    type: ListDataFiltersTypeEnum.TEXT,
    maxWidth: "200px",
    maskFormatter: cpfCnpjFormatter,
    valueFormatter: removeMask
  },
  {
    label: "Contato",
    placeholder: "Contato",
    filterQuery: "contact",
    type: ListDataFiltersTypeEnum.TEXT,
    maxWidth: "150px"
  },
  {
    label: "Nome da Unidade de Negócio",
    placeholder: "Unidade de Negócio",
    filterQuery: "businessUnitName",
    type: ListDataFiltersTypeEnum.TEXT,
    maxWidth: "200px"
  }
];
